var _div, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFirouzehWigth(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _div || (_div = /*#__PURE__*/React.createElement("div", {
    xmlns: "",
    id: "in-page-channel-node-id",
    "data-channel-name": "in_page_channel_R3ImDe"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.03125 11.9479L11.987 0.0102539L23.9404 12.0208L11.9846 23.9584L0.03125 11.9479ZM0.720212 11.949L11.9857 23.2683L23.2514 12.0197L11.9859 0.700337L0.720212 11.949Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6709 6.57601V5.87118C7.68427 6.91739 10.3697 9.10187 11.8872 12.275C13.3434 9.24859 15.8163 6.94328 20.0815 5.92009V6.59807C15.8958 7.83415 13.1701 10.0944 12.3563 13.7019H11.4181C10.3918 9.5497 7.32046 7.72387 3.6709 6.57601Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8882 2.82174C11.5081 4.75402 10.6761 6.40244 8.79964 7.39495C7.05623 8.2417 5.84418 9.35408 5.56558 11.3832C4.89732 11.1972 4.47224 11.4714 4.3047 12.2252C5.12327 12.0746 5.74748 12.8677 5.99066 14.0424C6.03949 14.1843 6.08831 14.2687 6.26926 14.2907C7.22473 15.3897 8.36211 15.7493 9.61916 15.6246C9.51289 16.1386 9.87095 16.7102 11.5129 17.6096C11.5263 19.0634 11.3626 20.4376 10.9068 21.6784H11.6766L11.8891 20.7828L12.1237 21.6516H12.8274C12.4243 20.3704 12.2481 19.0279 12.2874 17.6183C13.6632 16.9 14.3448 16.2268 14.1591 15.6016C15.2831 15.7876 16.3936 15.4424 17.486 14.3118C17.712 14.2898 17.8182 14.1431 17.8134 13.8909C18.1629 12.7027 18.7115 12.1091 19.4994 12.2021C19.3137 11.5155 18.902 11.1962 18.1897 11.3554C17.8489 8.47473 15.8489 7.97416 14.3008 6.94617C13.0667 6.09942 12.252 4.73484 11.8891 2.81982L11.8882 2.82174ZM11.8882 4.7895C11.5435 6.18093 10.6493 7.63948 9.24195 9.15462C7.62301 11.3976 8.47221 13.4536 11.8882 13.7019C15.3348 13.4852 16.0605 11.3084 14.5784 9.17667C13.1222 7.59058 12.2204 6.12723 11.8882 4.7895Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6799 16.9729C10.4406 18.2713 9.28598 20.2525 8.49422 19.8977L7.32621 19.3789C7.13568 20.0923 7.47652 21.5902 9.41906 20.5133C10.2108 19.9552 10.8657 18.9934 11.2553 17.2778L10.6799 16.9719V16.9729Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1174 16.9729C13.3568 18.2713 14.5114 20.2525 15.3031 19.8977L16.4664 19.3789C16.6607 20.0923 16.3199 21.5902 14.3783 20.5133C13.5865 19.9552 12.9317 18.9934 12.542 17.2778L13.1174 16.9719V16.9729Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFirouzehWigth);
export default __webpack_public_path__ + "static/media/logo-firouzeh-wigth.c07474f904ab8d2dff43ca5979833b39.svg";
export { ForwardRef as ReactComponent };